import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { Route as rootRoute } from './__root';
import { authGuard } from './guards';

const ForgotPassword = lazy(() => import('../views/default/ForgotPassword'));

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/forgot-password',
  beforeLoad: authGuard({ publicOnly: true }),
  component: ForgotPassword,
});
